<script>
    import KSTour from './../../../component/KSTour.vue'
    import {isCookieEnabled, getCookie, setCookie} from 'tiny-cookie'

    export default {
        components: {
            'ks-tour': KSTour
        },
        props: ["isOwner", "hasAds"],
        data () {
            return {
                steps: [
                    {
                        target: '#tour-step-0',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.0t")
                        },
                        content: this.$t("lang.report.dashboard.tour.0c"),
                        params: {
                            /*placement: 'top',*/
                        }
                    },
                    {
                        target: '#tour-step-1',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.1t")
                        },
                        content: this.$t("lang.report.dashboard.tour.1c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-2',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.2t")
                        },
                        content: this.$t("lang.report.dashboard.tour.2c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-3',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.3t")
                        },
                        content: this.$t("lang.report.dashboard.tour.3c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-4',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.4t")
                        },
                        content: this.$t("lang.report.dashboard.tour.4c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-5',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.5t")
                        },
                        content: this.$t("lang.report.dashboard.tour.5c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-6',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.6t")
                        },
                        content: this.$t("lang.report.dashboard.tour.6c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-7',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.7t")
                        },
                        content: this.$t("lang.report.dashboard.tour.7c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-8',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.8t")
                        },
                        content: this.$t("lang.report.dashboard.tour.8c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-9',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.9t")
                        },
                        content: this.$t("lang.report.dashboard.tour.9c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-10',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.10t")
                        },
                        content: this.$t("lang.report.dashboard.tour.10c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-11',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.11t")
                        },
                        content: this.$t("lang.report.dashboard.tour.11c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-12',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.12t")
                        },
                        content: this.$t("lang.report.dashboard.tour.12c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-13',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.13t")
                        },
                        content: this.$t("lang.report.dashboard.tour.13c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-14',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.14t")
                        },
                        content: this.$t("lang.report.dashboard.tour.14c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-15',
                        content: this.$t("lang.report.dashboard.tour.15c"),
                        params: {
                            placement: 'left',
                        }
                    },
                    {
                        target: '#tour-step-16',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.16t")
                        },
                        content: this.$t("lang.report.dashboard.tour.16c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-17',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.17t")
                        },
                        content: this.$t("lang.report.dashboard.tour.17c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-18',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.18t")
                        },
                        content: this.$t("lang.report.dashboard.tour.18c"),
                        params: {
                            placement: 'auto',
                        }
                    },
                    {
                        target: '#tour-step-19',
                        header: {
                            title: this.$t("lang.report.dashboard.tour.19t")
                        },
                        content: this.$t("lang.report.dashboard.tour.19c"),

                        params: {
                            placement: 'auto',
                        }
                    },
                ],
                callbacks: {
                }
            }
        },
        mounted: function () {
            this.callbacks.onStop = () => {
                document.querySelector('#tour-step-0').scrollIntoView({behavior: 'smooth'})
            };

            // @todo Tour временно отключили перед стартовым релизом, т.к. не верно определяет координаты
            this.$emitter.on('report-tour-start', () => {
                this.$tours['reportTour'].start();
            });

            if(isCookieEnabled() && !getCookie('keys.so_reportTour')){
                setTimeout(() => {
                    this.$tours['reportTour'].start();
                    const now = new Date;
                    now.setMonth(now.getMonth() + (12 * 12));
                    setCookie('keys.so_reportTour', 1, {expires: now.toGMTString()})
                }, 3000);
            }

        },
        methods: {
            contentClass(){
                return this.$tours['reportTour'].currentStep !== 0
            },
            modalClass(step){
                if(["#tour-step-0", "#tour-step-10", "#tour-step-12", "#tour-step-13", "#tour-step-14", "#tour-step-17", "#tour-step-18"].indexOf(step.target) !== -1){
                    return "w420";
                }
                if(["#tour-step-19"].indexOf(step.target) !== -1){
                    return "w520";
                }

                return "";
            }
        },
        computed: {
            stepsFiltered () {
                var self = this;
                return this.steps.filter((s) => {
                    if(!self.isOwner && s.target === "#tour-step-10"){
                        return false;
                    }

                    if(!self.hasAds && ["#tour-step-9", "#tour-step-12", "#tour-step-13", "#tour-step-14", "#tour-step-15"].indexOf(s.target) !== -1){
                        return false;
                    }

                    return s;
                });

            },

        },

    }
</script>

<template>
    <ks-tour name="reportTour" :steps="stepsFiltered" :callbacks="callbacks" :contentClass="contentClass" :modalClass="modalClass"></ks-tour>
</template>
